export const PROJECT_TYPES_ENUMS = {
  UNMODERATED: 'unmoderated',
  MODERATED: 'moderated',
  CARD_SORT: 'card_sort',
  TREE_TEST: 'tree_test',
  SURVEY: 'survey',
  UPLOAD: 'upload',
};

export const PROJECT_STATUS_ENUM = {
  DRAFT: 'draft',
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
};

export const PAYMENT_METHOD_ENUM = {
  VENMO: 'venmo',
  PAYPAL: 'paypal',
};
